import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '@app/shared/services/session.service';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { Actions } from '@src/app/shared/backend/auth/Action';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    host: {
        class: 'app-welcome'
    },
    standalone: false
})
export class WelcomeComponent implements OnInit {

  allowCreateSales: boolean = false;
  allowActivateWarranty: boolean = false;

  constructor(
    public session: SessionService,
    private router: Router,
    private permissionService: PermissionService,
  ) { }

  ngOnInit(): void {
    this.init();
  }

  async init(): Promise<void> {
    this.allowCreateSales = await this.permissionService.hasActionPermissions(Actions.create_sales);
    this.allowActivateWarranty = await this.permissionService.hasActionPermissions(Actions.activate_warranties);
  }

  async goToSales(): Promise<void> {
    await this.router.navigate(['/sales']);
  }

  async goToWarranties(): Promise<void> {
    await this.router.navigate(['/warranties']);
  }
}
